export default {
      id: "lock-usage",
      viewBox: "0 0 14 18",
      url: __webpack_public_path__ + "icons-sprite.396b316.svg#lock-usage",
      toString: function () {
        return this.url;
      }
    }